module.exports = __webpack_public_path__ + "experimental-data.png";